    import { Box,Button,Flex,Select,InputGroup,
      InputLeftElement,Input, Text, 
      TableContainer,Table,Thead,Tbody,Th,Tr,Td,Grid,GridItem, Checkbox,
      FormControl,
      FormLabel,
      InputRightElement,
      Stack,
      Radio,
      HStack} from "@chakra-ui/react";
    import { TopDisplay } from "../../../../components";
    import { IoMdAdd as AddIcon } from "react-icons/io";
    import { LuSearch as SearchIcon } from "react-icons/lu";
    import { useState,useEffect, useRef } from "react";
    import { useMutation, useQuery, useQueryClient } from 'react-query';
    import styled from "@emotion/styled";
    import { atom, useAtom } from 'jotai';
    import apiCall from '../../../../utils/apiCall';
    import {ExamPeriod, TopLink} from '../';
    import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
    import { Formik,Form,Field, ErrorMessage } from "formik";
    import {TablePopUp} from '../../../../components';
    import * as Yup from 'yup';
    import { format, setDate } from "date-fns";
    import { DateFilter} from '../../../../components';
    import { Loader } from "../../../../customs";
    import { TbReload as ReloadIcon } from "react-icons/tb";
    import ReactPaginate from 'react-paginate';
    import { IoReloadCircleOutline as ResetIcon} from "react-icons/io5";
    import ReactSelect from "../../../../components/Select";
    import appStore, { activePeriod } from "../../../../store";

   

    const HeadStyle={
      borderBottom:"1px solid var(--dark-green-color)",
      padding:'15px 5px',
    }
    const DataStyle = {
      padding:'5px 5px',
    }


    const ROWSTYLE = styled.tr`
      & > td:last-of-type > *{
        display:none;
      }
      :hover > td{
        background-color:var(--table-highlight);
        &:last-of-type > *{
          display:block;
        }
      } 
      &.active > td:last-of-type > *{
        display:block !important;
      }  
    `
    

//     const ExamExamSubjectFeeFeeAtom = atom<number | null>(null);


//     export default function ExamTimeTable() {
//       const [hide, set_hide] = useState<boolean>(true);
//       const [, set_modal] = useAtom(modalAtom);
//       const [, set_open] = useAtom(openAtom);
//       const [active] = useAtom<number | string | null>(ExamExamSubjectFeeFeeAtom);
//       // const [selected_examperiod,set_selected_examperiod] = useState<any>('');
//       // const [filter_data,set_filter_data] = useState<any>([allExamSubjectFee]);
//       const [selected_level,set_selected_level] = useState(null);
      
  
//   const { data: allExamSubjectFee, isLoading } = useQuery(
//   ['exam-subject-fee'],
//   {
//     queryFn: async () => {
//       const { data } = await apiCall().get(`/exam/setup/examSubjectFee`);
//       console.log("API data:", data);   // should show {StatusCode, Message, Data}
//       return data;
//     },
//     select(data) {
//       return data.Data;  // now very clear and direct
//     }
//   }
// );

// useEffect(() => {
//   if (allExamSubjectFee) {
//     set_filter_data(allExamSubjectFee);
//     currentItems(allExamSubjectFee); // or slice for pagination
//   }
// }, [allExamSubjectFee]);



//      const {data:examPeriods} = useQuery(["exam-period"],{
//         queryFn: async ()=> await apiCall().get(`/exam/setup/examPeriod`),
//         select: (data) => data?.data?.Data,
//         onSuccess(data) {
//             console.log(data,'exam period data')
//         },
//       })

//        const {data:allLevels} = useQuery(['exam-level'],{
//           queryFn:async ()=> await apiCall().get(`/SetUp/GetAllExemption`),
//           select(data){
//             return data.data.Data;
//           }
//         })


//       const [search,set_search] = useState('');
      

//      const handleSearch = (e: any) => {
//   const val = e.target.value;
//   set_search(val);

//   if (!val) {
//     set_filter_data(allExamSubjectFee);
//     return;
//   }

//   const filtered = allExamSubjectFee?.filter((item: any) => {
//     const values = Object.values(item)
//       .map(v => typeof v === 'object' && v !== null ? JSON.stringify(v) : v)
//       .join(' ')
//       .toLowerCase();

//     return values.includes(val.toLowerCase());
//   });

//   set_filter_data(filtered);
// };


//       // useEffect(()=>{
//       //   set_filter_data(allExamSubjectFee)
//       // },[allExamSubjectFee])

// const [filter_data, set_filter_data] = useState<any>([]);

//       const itemsPerPage = 10;
//       const [itemOffset, setItemOffset] = useState(0);
//       const endOffset = itemOffset + itemsPerPage;
//       console.log(`Loading items from ${itemOffset} to ${endOffset}`);
//       const currentItems = filter_data?.slice(itemOffset, endOffset);
//       const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

//       const handlePageClick = (event:any) => {
//         const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
//         console.log(
//           `User requested page number ${event.selected}, which is offset ${newOffset}`
//         );
//         setItemOffset(newOffset);
//       };

//       const handleAddTimeTable = () =>{
//         set_modal({
//           header:'Exam Subjects Fee',
//           content:<AddType />
//         })
//         set_open(true);
//       }

//       const handleSelected = (e: any) => {
//         let val = e.target.value;
//         console.log(val, 'level');
      
//         if (val && allExamSubjectFee) {
//           set_filter_data(allExamSubjectFee.filter((eSubject: any) => eSubject.LevelId == val));
          
//         } else {
//           set_filter_data(allExamSubjectFee);
//         }
      
//       }
//         useEffect(() => {
//       set_filter_data(allExamSubjectFee)
//     }, [allExamSubjectFee]);



//       return (
//         <>
//         {isLoading?<Loader />:
//         <Box>
//           <TopLink />
//           <TopDisplay label="Exam Subject Fee SetUp" button_array={[
//               <Button onClick={handleAddTimeTable} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<AddIcon/>}>Add Subject Fee</Button>
//             ]} />
//             <Flex  gap="20px" wrap="wrap" mt="20px">
//               <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
//                 <InputLeftElement pointerEvents='none'>
//                   <SearchIcon color='gray.300' />
//                 </InputLeftElement>
//                 <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
//                 <span style={{position:'absolute',zIndex:'1',
//                 right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
//               </InputGroup>
//               <Select placeholder="Level" width="100px" bg="var(--white-color)" 
//             borderColor="var(dark-green-color)" onChange={handleSelected}>
//               {allLevels && allLevels.length > 0 ? 
//               allLevels.map((eLevel:any) => <option key={eLevel.Id} value={eLevel.Id}>
//                 {eLevel.Name}
//               </option>):''}
//           </Select>           
//             </Flex>
//             <Flex mt="25px" flexDir="column" gap="10px">
//               <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
//             </Flex>
//         {  filter_data && filter_data.length > 0 ?  <TableContainer mt="20px">
//               <Table size='sm'>
//               <Thead>
//                 <Tr>
//                   <Th sx={HeadStyle}>Exam Diet</Th>
//                   <Th sx={HeadStyle}>Level</Th>
//                   <Th sx={HeadStyle}>Amount</Th>
//                   <Th sx={HeadStyle}>SubjectsCount</Th>
//                   <Th sx={HeadStyle}>Resit?</Th>
//                   <Th sx={HeadStyle} w="50px"></Th>
//                 </Tr>
//               </Thead>
//               <Tbody>
//                {filter_data.map((eExamSubjectFeeFee: any) => (
//               <ROWSTYLE key={eExamSubjectFeeFee.Id} className={eExamSubjectFeeFee.Id === active ? 'active' : ''}>
//               <Td sx={DataStyle}>
//                   {eExamSubjectFeeFee.ExamPeriod.ExamName || 'N/A'}
//                 </Td>
                
//                 {/* Level Name */}
//                 <Td sx={DataStyle}>
//                   {eExamSubjectFeeFee.Level.ExemptionName || 'N/A'}
//                 </Td>
                
//                 {/* Amount */}
//                 <Td sx={DataStyle}>
//                   {eExamSubjectFeeFee.Amount || 'N/A'}
//                 </Td>
                
//                 {/* Subjects Count */}
//                 <Td sx={DataStyle}>
//                   {eExamSubjectFeeFee.SubjectsCount || 0}
//                 </Td>
                
//                 {/* Resit? */}
//                 <Td sx={DataStyle}>
//                   {eExamSubjectFeeFee.IsResit ? 'True' : 'False'}
//                 </Td>

//                 {/* Actions */}
//                 <Td sx={DataStyle} w="50px" h="50px">
//                   <TempPopUp index={eExamSubjectFeeFee.Id} data={eExamSubjectFeeFee} />
//                 </Td>
//               </ROWSTYLE>
//             ))}

//               </Tbody>
//               </Table>
//             </TableContainer>
//             :'No Exam Subject Fee Found'  
//           }
//           <StylePaginateBox>
//             <ReactPaginate
//               breakLabel="..."
//               nextLabel=">"
//               onPageChange={handlePageClick}
//               pageRangeDisplayed={5}
//               pageCount={pageCount}
//               previousLabel="<"
//               renderOnZeroPageCount={null}
//             />

//           </StylePaginateBox>

//         </Box>
//         }
//         </>
        
//       )
//     }

const ExamSubjectFeeAtom = atom<number | null>(null);


export default function ExamSubjectFee() {
  const [hide,set_hide] = useState<boolean>(true);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_open] = useAtom(openAtom);
  const [active] = useAtom<number | string | null>(ExamSubjectFeeAtom);
  const [filter_data,set_filter_data] = useState<any>([]);
  const [selected_level, set_selected_level] = useState<string | null>(null);
  const [selected_examperiod, set_selected_examperiod] = useState<string | null>(null);
  const [search, set_search] = useState("");


  const {data:allLevels} = useQuery(['exam-level'],{
    queryFn:async ()=> await apiCall().get(`/SetUp/GetAllExemption`),
    select(data){
      return data.data.Data;
    }
  })

  const {data:allExamPeriod} = useQuery(['exam-periods'],{
        queryFn:async ()=> await apiCall().get(`/exam/setup/examPeriod`),
        select(data){
          //console.log(data,'exam-period')
          return data.data.Data;
        },
      })


  const {isLoading,data:allExamSubjectFee} = useQuery(['exam-subject'],{
    queryFn:async ()=> await apiCall().get(`/exam/setup/examSubjectFee`),
    select(data){
      return data.data.Data;
    }
  })
  

  const handleAddSubject = () =>{
    set_modal({
      header:'Exam subject Setup',
      content:<AddType />
    })
    set_open(true);
}

const applyFilters = () => {
  if (!allExamSubjectFee) return;

  let filtered = allExamSubjectFee;

  // Filter by exam period
  if (selected_examperiod) {
    filtered = filtered.filter(
      (item: any) => item.ExamPeriod?.Id?.toString() === selected_examperiod
    );
  }

  // Filter by level
  if (selected_level) {
    filtered = filtered.filter(
      (item: any) => item.LevelId?.toString() === selected_level
    );
  }

  // Filter by search
  if (search.trim()) {
    filtered = filtered.filter((item: any) =>
      Object.values(item)
        .map((v) =>
          typeof v === "object" ? JSON.stringify(v) : String(v)
        )
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  }

  set_filter_data(filtered);
};

// 3️⃣ Whenever any filter/search changes, re-apply
useEffect(() => {
  applyFilters();
}, [selected_level, selected_examperiod, search, allExamSubjectFee]);

// 4️⃣ Handlers
const handleSelectedLevel = (e: any) => {
  set_selected_level(e.target.value || null);
};

const handleChangePeriod = (value: any) => {
  set_selected_examperiod(value?.Id?.toString() || null);
};

const handleSearch = (e: any) => {
  set_search(e.target.value);
};

  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  //console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };
  // useEffect(()=>{
  //   if(selected_level){
  //     let data = allLevels.filter((eData:any) => eData.Status === selected_level);
  //     if(data.length > 0){
  //       set_filter_data(data);
  //     }
  //   }
  //   else{
  //     set_filter_data(allLevels);
  //   }
  // },[selected_level])

  // useEffect(()=>{
  //   set_filter_data(allExamSubjectFee)
  // },[allExamSubjectFee])


  return (
    <>
    {isLoading?<Loader />:
    <Box>
      <TopLink />
      <TopDisplay label="Exam Subject Fee SetUp" button_array={[
          <Button onClick={handleAddSubject} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<AddIcon/>}>Add Exam Subjects Fee</Button>
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
           <ReactSelect 
                        name="ExamName"
                        onChange={handleChangePeriod}
                        placeholder="Exam Period"
                        options={allExamPeriod?.map((e: any) => ({ ...e, ['label']: e.ExamName, ['value']: e.Id }))}
                      />
          <Select placeholder="Level" width="200px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)" onChange={handleSelectedLevel}>
              {allLevels && allLevels.length > 0 ? 
              allLevels.map((eLevel:any) => <option key={eLevel.Id} value={eLevel.Id}>
                {eLevel.Name}
              </option>):''}
          </Select>
          

        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
          <Text m="0" fontSize=".8rem">showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
     {   filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
                {/* <Th sx={HeadStyle}>Exam ID</Th> */}
                <Th sx={HeadStyle}>Examperiod</Th>
                <Th sx={HeadStyle}>Level</Th>
                <Th sx={HeadStyle}>Amount</Th>
                <Th sx={HeadStyle}>Subject-Count</Th>
                <Th sx={HeadStyle}>Resit?</Th>
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eExamSuject:any) =><ROWSTYLE key={eExamSuject.Id} className={eExamSuject.Id === active?'active':''}>
               <Td sx={DataStyle}>{eExamSuject.ExamPeriod?.ExamName}</Td>
                <Td sx={DataStyle}>{eExamSuject.Level?.ExemptionName || ''}</Td>
                <Td sx={DataStyle}>{eExamSuject.Amount}</Td>
                <Td sx={DataStyle}>{eExamSuject.SubjectsCount}</Td>
                <Td sx={DataStyle}>{eExamSuject.IsResit ? 'True' : 'False'}</Td>


                <Td sx={DataStyle} w="50px" h="50px">
                  <TempPopUp index={eExamSuject.Id} data={eExamSuject}/>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No Exam SubjectFee Found'  
      }
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

       </StylePaginateBox>
    </Box>
    }
    </>
    
  )
}


    const StylePaginateBox = styled.div`
      width:100%;
      & > ul{
        list-style-type: none;
        text-align:center;
        padding:0;
        margin:0;
        margin-top:10px;
      } 
      & > ul > li{
        display: inline;
        margin:0 5px;
        padding:2px 5px;
        border-radius: 3px;
        background-color: transparent;
        color:var(--dark-green-color);
      }
      & > ul > li.selected{
        background-color: var(--highlight-paginate-background);
        color:var(--highlight-paginate-color);
      }
      & > ul > li:first-of-type,
      & > ul > li:last-of-type{
        font-weight: bold;
      }
    `

  const AddSchema = Yup.object({
  ExamPeriodId: Yup.number().required(),
  LevelId: Yup.number().required(),
  SubjectsCount: Yup.number().required(),
  Amount: Yup.number().required(),
  IsResit: Yup.boolean().required(),
});


    const Label = styled.label``;  
    const monthOfYear = [
      'January','February','March','April','May',
      'June','July','August','September','October',
      'November','December'
    ]
    

   const AddType = (props: any) => {
  const queryClient = useQueryClient();
  const [, set_open] = useAtom(openAtom);
  const [, set_Nopen] = useAtom(openNAtom);
  const [, set_notification] = useAtom(notificationAtom);
  const formRef = useRef<any>(null);

  const { data: allLevels } = useQuery(['exam-level'], {
    queryFn: async () => await apiCall().get(`/SetUp/GetAllExemption`),
    select(data) {
      return data.data.Data;
    },
  });


    const {data:allExamPeriod} = useQuery(['exam-periods'],{
        queryFn:async ()=> await apiCall().get(`/exam/setup/examPeriod`),
        select(data){
          //console.log(data,'exam-period')
          return data.data.Data;
        },
      })

  const { mutate: addUpdate, isLoading } = useMutation({
    mutationKey: ['new-exam-subject-fee'],
    mutationFn: async (data: any) => {
      return props?.Id
        ? await apiCall().put(`/exam/setup/examSubjectFee/${props.Id}`, data)
        : await apiCall().post(`/exam/setup/examSubjectFee`, data);
    },
     onSuccess: (data: any) => {
          const message = props && props.Id
            ? 'ExamSubject Fee updated successfully'
            : 'ExamSubjects Fee added successfully';

          set_notification({
            type: 'success',
            message: data?.Message || message,
          });
          set_Nopen(true);
          queryClient.invalidateQueries({
            queryKey: ['exam-subject-fee'],
          });
        },
    onError: (error: any) => {
      set_notification({
        type: 'error',
        message: error?.response?.data?.Message || 'An error occurred',
      });
      set_Nopen(true);
    },
    onSettled: () => {
      set_open(false);
    },
  });

  return (
    <Formik
      innerRef={formRef}
      initialValues={{
        ExamPeriodId: props?.ExamPeriodId || '',
        LevelId: props?.LevelId || '',
        SubjectsCount: props?.SubjectsCount || '',
        IsResit: props?.IsResit || false,
        Amount: props?.Amount || '',
      }}
      validationSchema={AddSchema}
      onSubmit={(values: any) => {
      const payload = {
      ExamPeriodId: Number(values.ExamPeriodId),
      LevelId: Number(values.LevelId),
      SubjectsCount: Number(values.SubjectsCount),   // <== here
      IsResit: Boolean(values.IsResit),
      Amount: Number(values.Amount),
    };

        addUpdate(payload);
      }}
    >
      {({ values, errors, touched, setFieldValue }) => (
        <Form>
          <Flex flexDir="column" gap="16px">
           <Field
              as={Select}
              placeholder="Exam Period"
              bg="var(--white-color)"
              borderColor="green"
              name="ExamPeriodId"
              onChange={(e: any) => setFieldValue("ExamPeriodId", e.target.value)}
            >
              {allExamPeriod && allExamPeriod.length > 0
                ? allExamPeriod.map((eType: any) => (
                    <option key={eType.Id} value={eType.Id}>
                      {eType.ExamName}
                    </option>
                  ))
                : ''}
            </Field>



           <Field as={Select}
                  bg='var(--white-color)'
                  borderColor='var(--dark-green-color)'
                  color='var(--dark-green-color)'
                  placeholder='Select Level'
                  name="LevelId"
                >
                  {allLevels && allLevels.length > 0 ?
                    allLevels.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.Name}</option>)
                  :''}
                </Field>

            <Field name="SubjectsCount">
            {({ field, form }: any) => (
              <Input
                {...field}
                type="number"
                placeholder="Subjects Count"
                onChange={(e) => form.setFieldValue('SubjectsCount', Number(e.target.value))}
              />
            )}
          </Field>


            <Field name="Amount">
              {({ field }: any) => (
                <Input {...field} placeholder="Amount" type="number" />
              )}
            </Field>

           <Field name="IsResit">
            {({ field }: any) => (
              <FormControl as="fieldset">
                <FormLabel as="legend">Is Resit?</FormLabel>
                <HStack spacing="24px">
                <Radio
                  isChecked={field.value === true}
                  onChange={() => setFieldValue("IsResit", true)}
                >
                  Yes
                </Radio>
                <Radio
                  isChecked={field.value === false}
                  onChange={() => setFieldValue("IsResit", false)}
                >
                  No
                </Radio>

                </HStack>
              </FormControl>
            )}
          </Field>
            <Button
              type="submit"
              isLoading={isLoading}
             bg="var(--dark-green-color)"
              color="var(--white-color)"
            >
              {props?.Id ? 'Update' : 'Create'}
            </Button>
          </Flex>
        </Form>
      )}
    </Formik>
  );
};




    const SelectWrapper = styled.div`
      width:100%;
      & > div{
        width:100%;
      }
    `

    const TempPopUp = (props: any) => {
  const { index, data } = props;
  const [active, set_active] = useAtom(ExamSubjectFeeAtom);
  const [, set_open] = useAtom(openAtom);
  const [, set_modal] = useAtom(modalAtom);
  const [, set_Nopen] = useAtom(openNAtom);
  const [, set_notification] = useAtom(notificationAtom);
  const queryClient = useQueryClient();

  const { mutate: deleteExamSubjectFeeFee, isLoading } = useMutation({
    mutationKey: ['delete-exam-subjects-fee'],
    mutationFn: async () =>
      await apiCall().get(`/exam/setup/examSubjectFee/${data?.Id}/delete`),
    onSuccess(data: any) {
      queryClient.invalidateQueries({ queryKey: ['exam-subject-fee'] });
      set_notification({
        type: 'success',
        message: data?.data?.Message || 'Deleted Successfully',
      });
      set_Nopen(true);
    },
    onSettled() {
      set_open(false);
    },
  });

  const handleClick = () => {
    set_active(index === active ? null : index);
  };

  const handleView = () => {
    set_modal({
      header: 'View Exam Subject Fee',
      content: (
        <Grid>
          <GridItem as={Flex} justify="space-between" p="10px 0">
            <Text fontWeight="bold">ExamPeriod:</Text>
            <span>{data?.ExamPeriod?.ExamName}</span>
          </GridItem>
          <GridItem as={Flex} justify="space-between" p="5px 0">
            <Text fontWeight="bold">Level:</Text>
            <span>{data?.Level?.ExemptionName}</span>
          </GridItem>
          <GridItem as={Flex} justify="space-between" p="5px 0">
            <Text fontWeight="bold">Amount:</Text>
            <span>{data?.Amount}</span>
          </GridItem>
          <GridItem as={Flex} justify="space-between" p="5px 0">
            <Text fontWeight="bold">Subjects Count:</Text>
            <span>{data?.SubjectsCount}</span>
          </GridItem>
          <GridItem as={Flex} justify="space-between" p="5px 0">
            <Text fontWeight="bold">Is Resit:</Text>
            <span>{data?.IsResit ? 'Yes' : 'No'}</span>
          </GridItem>
        </Grid>
      ),
    });
    set_open(true);
    handleClick();
  };

  const handleEdit = () => {
    set_modal({
      header: 'Edit Exam Subject Fee',
      content: <AddType {...data} />,
    });
    set_open(true);
    handleClick();
  };

  const handleDelete = () => {
    set_modal({
      header: 'Delete Exam Subject Fee',
      content: (
        <Grid gap="20px">
          <GridItem>Are you sure you want to delete this record?</GridItem>
          <GridItem as={Flex} justify="space-between" p="20px 0">
            <Button
              disabled={isLoading}
              onClick={() => deleteExamSubjectFeeFee()}
              bg="var(--dark-green-color)"
              color="white"
            >
              {isLoading ? 'Loading' : 'Delete'}
            </Button>
            <Button
              onClick={() => set_open(false)}
              variant="outline"
              borderColor="var(--dark-green-color)"
            >
              Cancel
            </Button>
          </GridItem>
        </Grid>
      ),
    });
    set_open(true);
  };

  return (
    <TablePopUp
      click={handleClick}
      options={[
        { label: 'View SubjectFee', click: handleView },
        { label: 'Edit SubjectFee', click: handleEdit },
        // { label: 'Delete SubjectFee', click: handleDelete },
      ]}
    />
  );
};


